abstract class AuthenticationFrontendWithEmailAbstractApi {
    abstract start: (
        email: string
    ) => Promise<void>

    abstract complete: (
        email: string,
        code: string
    ) => Promise<{
        token: string,
        user: string
    }>
}

export {
    AuthenticationFrontendWithEmailAbstractApi
}
